import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import './App.css';
import Footer from './components/Footer';
import Header from './components/Header';
import Menu from './components/Menu';
import Login from './components/Login';
import { LanguageProvider } from './translations/LanguageContext';
import Dashboard from './dashboard/Dashboard';

// Protected route component that checks for authentication
function ProtectedRoute({ children }) {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check if the encrypted password exists in localStorage
    const hasPassword = localStorage.getItem('encryptedPassword');
    setIsAuthenticated(!!hasPassword);
    setLoading(false);
  }, []);

  if (loading) {
    return <div>Loading...</div>;
  }

  // If not authenticated, redirect to login page
  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }

  // If authenticated, render the protected component
  return children;
}

function MainLayout() {
  return (
    <LanguageProvider>
      <div className='flex flex-col min-h-screen font-baskerville bg-slate-50 dark:bg-gray-900'>
        <Header />
        <Menu />
        <Footer />
      </div>
    </LanguageProvider>
  );
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<MainLayout />} />
        <Route path="/login" element={<Login />} />
        <Route 
          path="/dashboard" 
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          } 
        />
      </Routes>
    </Router>
  );
}

export default App;